import React from 'react'
import { Radio } from 'SRC/ui/FormElements/Radio'

const options = [
  {
    label: 'Muški',
    value: 'm',
    className: 'muski-pol-radio'
  },
  {
    label: 'Ženski',
    value: 'f',
    className: 'zenski-pol-radio'
  }
]

export const Gender = () =>
  <div className='form-pol'>
    <label>Pol: <span className='required'>*</span>
      <span className='lead-label'>(kliknite na sličicu)</span>
    </label>
    <Radio name='gender' options={options} />
  </div>
